import { useState, useContext } from "react";

// Import Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";

// Hooks
import { useDeleteStaffOrder } from "../../hooks/useDeleteStaffOrder";
import { useCheckAPI } from "../../hooks/useCheckAPI";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const DeleteStaffDialog = ({ staffLineNo, staffName, orderNo }) => {
  const { mutate, isSuccess, data } = useDeleteStaffOrder();
  const [open, setOpen] = useState(false);
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleClickOpen = () => {
    // clearStaffSelection();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    const deleteStaff = {
      data: {
        filter: { noFilter: orderNo, staffLineNo: staffLineNo },
        order: { no: orderNo },
      },
    };
    mutate(deleteStaff);
    // setOpen(false);
  };

  // API call success
  const successFunc = () => {
    setOpen(false);
    setAlertNotification({
      message: `${staffName} removed from ${orderNo}`,
      severity: "info",
    });
  };

  // API call error
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "warning",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box>
      <IconButton
        aria-label="delete-staff-member"
        color="error"
        onClick={handleClickOpen}
      >
        <DeleteIcon />
      </IconButton>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-staff-dialog"
      >
        <DialogTitle id="delete-staff-dialog-title">
          Remove {staffName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove {staffName} from order {orderNo}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDelete}>Remove</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
